import { Entity, EntityAspect, EntityType } from 'breeze-client';

export class AuthBaseEntity implements Entity {
    entityAspect: EntityAspect;
    entityType: EntityType;
}
